import {
  AUTH_LOGIN,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_GET_STATUS,
  AUTH_GET_STATUS_SUCCESS,
  AUTH_GET_STATUS_FAILURE,
  AUTH_LOGOUT,
  NOTICE_OFF
} from '../actions/ActionTypes';

const initialState = {
  login: {
    status: 'INIT'
  },
  status: {
    valid: false,
    isLoggedIn: false,
    currentUser: '',
    currentRole: '',
    noticeOn: false
  },
  register: {
    status: 'INIT',
    error: -1
  }
};

const AuthManager = (state, action) => {
  if (typeof state === "undefined" ){
    state = initialState;
  }

  switch(action.type) {
    case AUTH_LOGIN:
      return {
        login: {
          status: 'WAITING'
        },
        status: state.status,
        register: state.register
      };
    case AUTH_LOGIN_SUCCESS:
      return {
        login: {
          status: 'SUCCESS'
        },
        status: {
          isLoggedIn: true,
          currentUser: action.email,
          currentRole: action.role,
          valid: state.status.valid,
          noticeOn: true
        },
        register: state.register
      };
    case AUTH_LOGIN_FAILURE:
      return {
        login: {
          status: 'FAILURE'
        },
        status: state.status,
        register: state.register,
      };
    case AUTH_LOGOUT:
      return {
        login: state.login,
        status: {
          isLoggedIn: false,
          currentUser: '',
          currentRole: '',
          valid: state.status.valid,
          noticeOn: false
        },
        register: state.register
      };
    case AUTH_GET_STATUS:{
      return {
        login: state.login,
        status: {
          isLoggedIn: true,
          currentUser: state.status.currentUser,
          currentRole: state.status.currentRole,
          valid: state.status.valid,
          noticeOn: state.status.noticeOn
        },
        register: state.register
      }
    }
    case AUTH_GET_STATUS_SUCCESS:{
      return {
        login: state.login,
        status: {
          // isLoggedIn: state.status.isLoggedIn,
          isLoggedIn: true,
          valid: true,
          currentUser: action.email,
          currentRole: action.role,
          noticeOn: state.status.noticeOn
        },
        register: state.register
      }
    }
    case AUTH_GET_STATUS_FAILURE:
      return {
        login: state.login,
        status: {
          valid: false,
          isLoggedIn: false,
          // currentUser: state.status.currentUser,
          // currentRole: state.status.currentRole
          currentUser: '',
          currentRole: '',
          noticeOn: false
        },
        register: state.register
      }
    case NOTICE_OFF:
      return {
        login: state.login,
        status: {
          valid: state.status.valid,
          isLoggedIn: state.status.isLoggedIn,
          currentUser: state.status.currentUser,
          currentRole: state.status.currentRole,
          noticeOn: false
        },
        register: state.register
      }
    default:
      return state;
  }
}

export default AuthManager;